const cellNames = {
  blogs_list: ["ردیف", "عنوان", "تگ ها", "عکس", "تاریخ", "حذف"],
  blog_tags: ["ردیف", "عنوان", "لینک", "حذف"],
  advs_list: [
    "ردیف",
    "عنوان",
    "زیردسته اصلی",
    "منطقه",
    "محله",
    "نوع قرارداد",
    "نوع ملک",
    "نوع سند",
    "حذف",
  ],
};

export default function generateHeadCells(pageName) {
  return cellNames[pageName].map((items, index) => ({
    id: `${pageName} headCell ${index}`,
    numeric: false,
    disableadding: false,
    label: items,
  }));
}
